/**
 * @desc 授权记录导出
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  body: defs.basics.AuthorizationRecordRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/authorizationRecord/export`, {
      method: "GET",

      data: body,
      ...options,
    }),
  );
}
